/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Title_2Inputs */

const en_contact_title_2 = /** @type {(inputs: Contact_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you’d hand to a system.`)
};

const lv_contact_title_2 = /** @type {(inputs: Contact_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uzticētu sistēmai.`)
};

/**
* | output |
* | --- |
* | "you’d hand to a system." |
*
* @param {Contact_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_title_2 = /** @type {((inputs?: Contact_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_title_2(inputs)
	return en_contact_title_2(inputs)
});